export const boxShadow = [
  '0px 2px 4px rgba(0, 0, 0, 0.25)' //0
];

export const colors = {
  black: '#000',
  white: '#fff',
  primary: ['#00416A', '#5896BB', '#7DC2F0'],
  info: [
    '#E6EEFF', //0
    '#CCDDFF', //1
    '#B3CCFF', //2
    '#99BBFF', //3
    '#80AAFF', //4
    '#6699FF', //5
    '#4D88FF', //6
    '#3377FF', //7
    '#1A66FF', //8
    '#004DE6', //9
    '#0044CC', //10
    '#003CB3', //11
    '#003399', //12
    '#002B80', //13
    '#002266', //14
    '#001A4D' //15
  ],
  //màu tự thêm, không có trong bảng màu design
  //không đổi thứ tự
  info_extra: [
    '#2A5F80', //0 màu root menu active
    '#639dd1f5', //1 màu sub menu hover
    '#3879B1' //2 màu sub menu active
  ],
  background: [
    '#F8FCFE' //bg xanh nhạt
  ],
  gradientHeader: 'linear-gradient(90.18deg, #00416A 12.85%, #5896BB 89.2%)',
  gradientHeaderHover: 'linear-gradient(90deg, #022840 12.85%, #167ebc 89.2%)'
  //thêm màu khác ở đây, warning, danger, success,...
};
